import React, { useState, useEffect, Fragment } from "react";

const AssetListTable = (
    emptypeData,
    handleDelAsset,
    handleSelectedItem,
    toggleFromGridViews,
    toggleFromListViews
) => {
  const [thead] = useState(["Item", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = emptypeData.map((el) => {
      return {
        "Item": el.itemName,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"       
              style={{ marginRight: "10px", cursor: "pointer" }}       
              onClick={() => {
                handleSelectedItem(el,el.itemId);
                toggleFromListViews();

             }}
            ></i> &nbsp;
            <i
              className="fas fa-trash"
              onClick={() => handleDelAsset(el.itemId)}
            ></i>
              
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    emptypeData,
    handleDelAsset,
    handleSelectedItem,
    toggleFromGridViews,
    toggleFromListViews
  ]);

  return { thead, trow };
};

export default AssetListTable;